module.exports = __webpack_public_path__ + "static/media/news-stc.64669d1c.jpg";